import { Component, Input, OnInit } from '@angular/core';

const DEFAULT_MIN_HEIGHT = '0px';

@Component({
  selector: 'no-kno-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  @Input() position: 'center' | 'fixed' = 'center';
  @Input() minHeight:string = DEFAULT_MIN_HEIGHT;
  defaultMinHeight = DEFAULT_MIN_HEIGHT;

  constructor() { }

  ngOnInit(): void {
  }

}
